import {Component, Prop, Vue} from "vue-property-decorator";
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';

export type TimePickerData = {
  hh?:string;
  HH?:string;
  mm?:string;
  ss?:string;
};

const defaultFormat = "HH:mm";

export function getNullTimePickerData(){
  return {HH: "", mm:"", ss:""};
}

@Component
export class TimePicker extends Vue {

  @Prop({type: [Object, null]}) value: TimePickerData;
  @Prop({type: String, default: defaultFormat}) format: string;
  @Prop({type: Boolean, default: true}) showClearButton: boolean;

  emit(v){
    this.$emit("input", v);
  }

  render() {
    return <VueTimepicker
      format={this.format}
      value={this.value}
      onInput={this.emit}
      input-class="input is-small"
      hide-clear-button={ ! this.showClearButton}
    />
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-10ae62b8/time-picker.tsx" });